import { Routes, Route } from "react-router-dom";

import Home from "../routes/Home";
import NotMatch from "../routes/NotMatch";
import Mda from "../routes/Mda/mda";
import App from "../App";
import MdaTrackTicket from "../routes/MdaTrackTicket/mdatrackticket";
import MdaRequest from "../routes/MdaReq/mdareq";
import MdaForm from "../routes/MdaForm/mdaform";
import SurveyForm from "../routes/SurveyForm/surveyform";
import SurveySuccessScreen from "../screens/SuccessSreen/SurveySuccessScreen";

const WebForm = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="mdaform" element={<MdaForm />} />
      <Route path="mda" element={<Mda />} />
      <Route path="survey" element={<SurveyForm />} />
      <Route path="survey-success" element={<SurveySuccessScreen />} />
      <Route path="mdarequest" element={<MdaRequest />} />
      <Route path="track" element={<MdaTrackTicket />} />
      <Route path=":formName" element={<App />} />
      <Route path="*" element={<NotMatch />} />
    </Routes>
  );
};
export default WebForm;
